import { FieldOption, RouterTargetType } from '@common/entities';

interface FieldOptionRequest extends Pick<FieldOption, 'id' | 'name' | 'sequence' | 'label'> {
  routeToApplicationId?: string | null;
  routeToFieldId?: string | null;
}

type FieldOptionWithRouting = FieldOption &
  Pick<FieldOptionRequest, 'routeToApplicationId' | 'routeToFieldId'>;

export function prepareFieldOptionsRequest(
  options: FieldOptionWithRouting[] | undefined,
): FieldOptionRequest[] | undefined {
  return options?.map((option) => {
    const { id, name, sequence, label, target, routeToApplicationId, routeToFieldId } = option;
    // Explicit IDs (including null when clearing a route) override the read-model target.
    const hasExplicitRouting = routeToApplicationId !== undefined || routeToFieldId !== undefined;
    let routing = { routeToApplicationId, routeToFieldId };
    if (!hasExplicitRouting && target?.type === RouterTargetType.Application) {
      routing = { routeToApplicationId: target.id, routeToFieldId: null };
    } else if (!hasExplicitRouting && target?.type === RouterTargetType.Field) {
      routing = { routeToApplicationId: null, routeToFieldId: target.id };
    }

    return {
      id,
      name,
      sequence,
      label,
      ...routing,
    };
  });
}
